import { render, staticRenderFns } from "./BaseLogoPartner.vue?vue&type=template&id=d7bc9aa2&scoped=true"
import script from "./BaseLogoPartner.vue?vue&type=script&lang=js"
export * from "./BaseLogoPartner.vue?vue&type=script&lang=js"
import style0 from "./BaseLogoPartner.vue?vue&type=style&index=0&id=d7bc9aa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7bc9aa2",
  null
  
)

export default component.exports